import './requestData.scss';
import Dates from '../../atoms/text/dates';
import SpanGray from '../../atoms/text/spanGray';
import SpanOrange from '../../atoms/text/spanOrange';
import RequestDataConstants from '../../../constants/request-data-constants';

const RequestData = (props) => {
    const constants = RequestDataConstants;

    const setComponent = (code) => {
        switch (code.type) {
            case constants.CASE_ORANGE:
                return (<SpanOrange MostrarValor={code.value} date={props.date}></SpanOrange>)
            case constants.CASE_DATE:
                return (<Dates Min={code.min} Values={code.value} Max={code.max} onChange={e => { code.callback(e) }} />)
            default:
                return (
                    <span className={`m-requestContainer_span${props.date ? '-date' : ''}--text`}>
                        {code.value}
                    </span>
                )
        }
    }

    return (
        <div className={`m-requestContainer ${props.date ? '' : 'approve'}`}>
            {
                props.data.map((element, index) => {
                    return (
                        <div key={index} className={`m-requestContainer_span${props.date ? '-date' : ''}`}>
                            <SpanGray key={index} MostrarValor={element.tag} />
                            {setComponent(element)}
                        </div>
                    )
                })
            }
        </div>
    )
}

export default RequestData;